import { PartyPopperIcon } from 'lucide-react'

import { Body } from './Body'

import type { Announcement } from '../types'

export const fiestasPatriasAnnouncement: Announcement = {
  version: '3.1.2',
  date: '2026-09-14',
  title: '¡Felices Fiestas Patrias!',
  summary: 'Un saludo del equipo Veekls para el Dieciocho.',
  kicker: 'Un saludo del equipo Veekls',
  label: 'Fiestas Patrias · 18 de septiembre de 2026',
  icon: PartyPopperIcon,
  Body,
}
